import { Article } from '../../types'

export const MOCK_SPORTS_ARTICLES: Article[] = [
  {
    source: {
      name: 'ESPN',
    },
    title:
      'Sources - Edge rusher Marcus Davenport, Vikings reach 1-year deal - ESPN',
    author: null,
    url: 'https://www.espn.com/nfl/story/_/id/35856559/sources-edge-rusher-marcus-davenport-vikings-reach-1-year-deal',
    urlToImage:
      'https://a.espncdn.com/combiner/i?img=%2Fphoto%2F2023%2F0216%2Fr1132278_1296x729_16%2D9.jpg',
    publishedAt: '2023-03-14T12:13:54Z',
  },
  {
    source: {
      name: 'CBS Sports',
    },
    title:
      '2023 World Baseball Classic scores, results, WBC standings: Team USA one win from quarterfinals - CBS Sports',
    author: '',
    url: 'https://www.cbssports.com/mlb/news/2023-world-baseball-classic-scores-results-wbc-standings-team-usa-one-win-from-quarterfinals/',
    urlToImage:
      'https://sportshub.cbsistatic.com/i/r/2023/03/14/2e83d8a0-9436-4ef3-8ee8-7c718ed59972/thumbnail/1200x675/82ed7c9b81b61bfefa97aac8be03ae53/usa-wbc-getty.png',
    publishedAt: '2023-03-14T11:49:00Z',
  },
  {
    source: {
      name: 'CBS Sports',
    },
    title:
      'Team USA score: U.S. blows out Canada in World Baseball Classic as Mike Trout homers in nine-run first inning - CBS Sports',
    author: 'Mike Axisa',
    url: 'https://www.cbssports.com/mlb/news/team-usa-score-u-s-blows-out-canada-in-world-baseball-classic-as-mike-trout-homers-in-nine-run-first-inning/live/',
    urlToImage:
      'https://sportshub.cbsistatic.com/i/r/2023/03/14/86ff2e35-97cf-4a8e-80dc-1ce2d0fb6f0b/thumbnail/1200x675/fb448934fcb3d155b9e58cb971969ff9/usa-wbc-getty-1.png',
    publishedAt: '2023-03-14T11:41:00Z',
  },
  {
    source: {
      name: 'CNN',
    },
    title: "NFL free agency: Who's going where and what to expect - CNN",
    author: 'Ben Morse',
    url: 'https://www.cnn.com/2023/03/14/sport/nfl-free-agency-preview-2023-spt-intl/index.html',
    urlToImage:
      'https://media.cnn.com/api/v1/images/stellar/prod/230313115617-aaron-rodgers-lamar-jackson-split-restricted.jpg?c=16x9&q=w_800,c_fill',
    publishedAt: '2023-03-14T11:29:00Z',
  },
  {
    source: {
      name: 'Yahoo Entertainment',
    },
    title:
      'March Madness 2023: NCAA tournament printable brackets, dates, times and more - Yahoo Sports',
    author: 'Ryan Young',
    url: 'https://sports.yahoo.com/march-madness-2023-ncaa-basketball-tournament-printable-brackets-dates-times-and-more-112340630.html',
    urlToImage:
      'https://s.yimg.com/os/creatr-uploaded-images/2023-03/d485be51-c12c-11ed-9f3f-148c8b08a5d9',
    publishedAt: '2023-03-14T11:23:40Z',
  },
  {
    source: {
      name: 'Dawgs By Nature',
    },
    title:
      'NFL free agency: Browns could add Larry Ogunjobi, Morgan Fox, others - Dawgs By Nature',
    author: 'JaredMueller',
    url: 'https://www.dawgsbynature.com/2023/3/14/23639272/2023-nfl-free-agency-browns-larry-ogunjobi-greg-gaines-morgan-fox-dalvin-tomlinson',
    urlToImage:
      'https://cdn.vox-cdn.com/thumbor/haXTD72H4J-5JTdeFw90kpoVk4k=/0x0:3785x1982/fit-in/1200x630/cdn.vox-cdn.com/uploads/chorus_asset/file/24506245/1289777422.jpg',
    publishedAt: '2023-03-14T11:07:56Z',
  },
  {
    source: {
      name: 'The Athletic',
    },
    title:
      'How does Bobby Okereke fit in Giants defense? Why New York added former Colts LB - The Athletic',
    author: 'Dan Duggan',
    url: 'https://theathletic.com/4306240/2023/03/13/bobby-okereke-giants-free-agency/',
    urlToImage:
      'https://cdn.theathletic.com/app/uploads/2023/03/13211557/GettyImages-1245851946-scaled-e1678756666780-1024x682.jpg',
    publishedAt: '2023-03-14T09:20:50Z',
  },
  {
    source: {
      name: 'Footballoutsiders.com',
    },
    title: 'Recapping Day 1 of NFL Free Agency - Football Outsiders',
    author: null,
    url: 'https://www.footballoutsiders.com/extra-points/2023/recapping-day-1-nfl-free-agency',
    urlToImage:
      'https://www.footballoutsiders.com/files/coverphotos/USATSI_17346430.jpg',
    publishedAt: '2023-03-14T05:26:04Z',
  },
  {
    source: {
      name: 'NBCSports.com',
    },
    title:
      'Warriors observations: Defense, Klay Thompson fuel win over Suns - NBC Sports',
    author: null,
    url: 'https://www.nbcsports.com/bayarea/warriors/warriors-observations-defense-klay-thompson-fuel-win-over-suns',
    urlToImage:
      'https://www.nbcsports.com/sites/rsnunited/files/styles/metatags_opengraph/public/article/hero/Klay-Thompson-Shooting-USATSI-20225516.jpg',
    publishedAt: '2023-03-14T05:21:48Z',
  },
  {
    source: {
      name: 'Associated Press',
    },
    title:
      "'Fosbury Flop' high jumper Dick Fosbury dies at 76 - The Associated Press - en Español",
    author: 'Eddie Pells',
    url: 'https://apnews.com/article/fosbury-flop-death-high-jump-eb1dee13fb2fec4072b9955545466d86',
    urlToImage:
      'https://storage.googleapis.com/afs-prod/media/d9265080496d46b0af96554cc26fded8/2939.webp',
    publishedAt: '2023-03-14T05:21:33Z',
  },
  {
    source: {
      name: 'YouTube',
    },
    title: 'NHL Highlights | Stars vs. Kraken - March 13, 2023 - SPORTSNET',
    author: null,
    url: 'https://www.youtube.com/watch?v=pDi30GkLrPc',
    urlToImage: 'https://i.ytimg.com/vi/pDi30GkLrPc/maxresdefault.jpg',
    publishedAt: '2023-03-14T04:50:01Z',
  },
  {
    source: {
      name: 'Dawgs By Nature',
    },
    title:
      'NFL free agency rumor: Browns, Dalvin Tomlinson agree to a big deal - Dawgs By Nature',
    author: 'Ezweav, JaredMueller',
    url: 'https://www.dawgsbynature.com/2023/3/14/23639136/cleveland-browns-dalvin-tomlinson-kevin-stefanski-andrew-berry-javon-hargraves-dremont-jones',
    urlToImage:
      'https://cdn.vox-cdn.com/thumbor/SGbHWDSf2Ch5hGS3JfVny4SOZF4=/0x0:2500x1309/fit-in/1200x630/cdn.vox-cdn.com/uploads/chorus_asset/file/24505945/usa_today_16885691.jpg',
    publishedAt: '2023-03-14T04:35:42Z',
  },
  {
    source: {
      name: 'YouTube',
    },
    title:
      'Bianca Andreescu vs. Iga Swiatek | 2023 Indian Wells Round 3 | WTA Match Highlights - WTA',
    author: null,
    url: 'https://www.youtube.com/watch?v=l1exjmQH5G4',
    urlToImage: 'https://i.ytimg.com/vi/l1exjmQH5G4/maxresdefault.jpg',
    publishedAt: '2023-03-14T03:52:48Z',
  },
  {
    source: {
      name: 'The Athletic',
    },
    title:
      'Raiders’ free-agent fits: Focus shifts to defense, O-line after adding Jimmy Garoppolo - The Athletic',
    author: 'Tashan Reed',
    url: 'https://theathletic.com/4304893/2023/03/13/raiders-best-remaining-free-agents/',
    urlToImage:
      'https://cdn.theathletic.com/app/uploads/2023/03/13215349/GettyImages-1425625137-1024x683.jpg',
    publishedAt: '2023-03-14T03:33:12Z',
  },
  {
    source: {
      name: 'YouTube',
    },
    title: 'CELTICS at ROCKETS | FULL GAME HIGHLIGHTS | March 13, 2023 - NBA',
    author: null,
    url: 'https://www.youtube.com/watch?v=XLqdlqRnRvw',
    urlToImage: 'https://i.ytimg.com/vi/XLqdlqRnRvw/maxresdefault.jpg',
    publishedAt: '2023-03-14T02:51:21Z',
  },
  {
    source: {
      name: 'Buffalo Rumblings',
    },
    title:
      'Buffalo Bills rework Josh Allen, Von Miller contracts, create nearly $32M in cap space, per report - Buffalo Rumblings',
    author: 'Matt Byham',
    url: 'https://www.buffalorumblings.com/2023/3/13/23638974/buffalo-bills-rework-contracts-for-josh-allen-von-miller-create-nearly-32m-in-nfl-salary-cap-space',
    urlToImage:
      'https://cdn.vox-cdn.com/thumbor/DWX8BsNlcQy2F6Q4HmeSbkJ3dD8=/0x237:3744x2197/fit-in/1200x630/cdn.vox-cdn.com/uploads/chorus_asset/file/24505731/1443048875.jpg',
    publishedAt: '2023-03-14T02:21:34Z',
  },
  {
    source: {
      name: 'YouTube',
    },
    title:
      'NHL Highlights | Sabres vs. Maple Leafs - March 13, 2023 - SPORTSNET',
    author: null,
    url: 'https://www.youtube.com/watch?v=e3nBIniPdk8',
    urlToImage: 'https://i.ytimg.com/vi/e3nBIniPdk8/maxresdefault.jpg',
    publishedAt: '2023-03-14T02:18:33Z',
  },
  {
    source: {
      name: 'WKRC TV Cincinnati',
    },
    title:
      "What to know if you're traveling to watch Xavier or NKU in the NCAA tournament - WKRC TV Cincinnati",
    author: 'Brad Underwood, WKRC',
    url: 'https://local12.com/news/local/xavier-northern-kentucky-university-ncaa-tournament-midwest-region-seed-nku-norse-musketeers-march-madness-basketball-bracket-fan-travel-watch-game-greensboro-north-carolina-birmingham-alabama-cincinnati-ohio',
    urlToImage:
      'https://local12.com/resources/media/6f15eb16-5448-4af7-a46f-dcb8fd3e62d0-large16x9_PMARCHMADNESSTRAVEL_frame_726.jpeg?1678760010272',
    publishedAt: '2023-03-14T02:15:00Z',
  },
  {
    source: {
      name: 'Tennessean',
    },
    title:
      'Tennessee Titans DE DeMarcus Walker signing with Chicago Bears - Tennessean',
    author: 'Nick Suss',
    url: 'https://www.tennessean.com/story/sports/nfl/titans/2023/03/13/demarcus-walker-signing-tennessee-titans-chicago-bears-nfl-free-agency/69995842007/',
    urlToImage:
      'https://www.gannett-cdn.com/presto/2022/12/30/PNAS/4302bd6a-e59e-4d4a-bbfd-956a76696c76-NAS-Titans-Cowboys-036.jpg?crop=3999,2250,x0,y0&width=3200&height=1801&format=pjpg&auto=webp',
    publishedAt: '2023-03-14T02:09:28Z',
  },
  {
    source: {
      name: '247Sports',
    },
    title:
      'Hubert Davis Focused on Moving Forward, Preparing for Next Season - 247Sports',
    author: 'Ross Martin',
    url: 'https://247sports.com/college/north-carolina/Article/Hubert-Davis-Focused-on-Moving-Forward-Preparing-for-Next-Season-UNC-Basketball-206374134/',
    urlToImage:
      'https://s3media.247sports.com/Uploads/Assets/725/642/11642725.jpg?fit=bounds&crop=1200:630,offset-y0.50&width=1200&height=630',
    publishedAt: '2023-03-14T02:06:48Z',
  },
  {
    source: {
      name: 'YouTube',
    },
    title: 'INSANE ENDING Final 2:40 Jazz vs Heat | March 13, 2023 - NBA',
    author: null,
    url: 'https://www.youtube.com/watch?v=VWaXf4Q0Gh4',
    urlToImage: 'https://i.ytimg.com/vi/VWaXf4Q0Gh4/maxresdefault.jpg',
    publishedAt: '2023-03-14T02:06:17Z',
  },
  {
    source: {
      name: 'NHL News',
    },
    title: 'Svechnikov Out Indefinitely With Knee Injury - NHL.com',
    author: 'Canes PR',
    url: 'https://www.nhl.com/hurricanes/news/svechnikov-out-indefinitely-with-knee-injury/c-342196888',
    urlToImage:
      'https://cms.nhl.bamgrid.com/images/photos/342197018/1024x576/cut.png',
    publishedAt: '2023-03-14T02:05:01Z',
  },
  {
    source: {
      name: 'Yahoo Entertainment',
    },
    title:
      "With first spring training start, Jacob deGrom takes first step toward delivering on Rangers fans' hope - Yahoo Sports",
    author: 'Hannah Keyser',
    url: 'https://sports.yahoo.com/with-first-spring-training-start-jacob-degrom-takes-first-step-toward-delivering-on-rangers-fans-hope-015039568.html',
    urlToImage:
      'https://s.yimg.com/ny/api/res/1.2/ZVJbikZD0CmzxLgSXNjRZg--/YXBwaWQ9aGlnaGxhbmRlcjt3PTEyMDA7aD04MDA-/https://s.yimg.com/os/creatr-uploaded-images/2023-03/dc800ab0-c204-11ed-96fe-03bde5722ea7',
    publishedAt: '2023-03-14T01:50:00Z',
  },
  {
    source: {
      name: 'ESPN',
    },
    title:
      "Puerto Rico's De Leon, bullpen 'perfect' in WBC mercy-rule win - ESPN",
    author: 'Jeff Passan',
    url: 'https://www.espn.com/mlb/story/_/id/35854296/puerto-rico-de-leon-bullpen-author-perfect-game-wbc-win',
    urlToImage:
      'https://a4.espncdn.com/combiner/i?img=%2Fphoto%2F2023%2F0314%2Fr1144185_1296x729_16%2D9.jpg',
    publishedAt: '2023-03-14T01:47:42Z',
  },
  {
    source: {
      name: 'Cincy Jungle',
    },
    title:
      'Bengals let Vonn Bell join Panthers: Was it the right move? - Cincy Jungle',
    author: 'PatrickJudis',
    url: 'https://www.cincyjungle.com/2023/3/13/23638869/bengals-vonn-bell-contract-panthers-free-agents-2023',
    urlToImage:
      'https://cdn.vox-cdn.com/thumbor/O_6gE0nTYfbl6uxw_lIAJZhMYdo=/0x353:6977x4006/fit-in/1200x630/cdn.vox-cdn.com/uploads/chorus_asset/file/24505494/1460295770.jpg',
    publishedAt: '2023-03-14T01:41:38Z',
  },
]
